export default "__VITE_ASSET__DqW81jgb__"